import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopyinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Duplicate/24px",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M13.4806248,7 L20,7 C20.5522847,7 21,7.44771525 21,8 L21,20 C21,20.5522847 20.5522847,21 20,21 L10,21 C9.44771525,21 9,20.5522847 9,20 L9,12.3507811 C9,12.1237096 9.07728075,11.9033991 9.21913119,11.726086 L12.699756,7.37530495 C12.8895282,7.13808972 13.1768411,7 13.4806248,7 Z",
				id: "Rectangle-33",
				stroke: "#000000",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("polyline", {
				id: "Rectangle-2",
				stroke: "#000000",
				strokeWidth: 2,
				strokeLinecap: "square",
				points: "14 8 14 12 10 12"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9,17 L4,17 C3.44771525,17 3,16.5522847 3,16 L3,8 L7,3 L14,3 C14.5522847,3 15,3.44771525 15,4 L15,7",
				id: "Rectangle-33",
				stroke: "#000000",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("polyline", {
				id: "Rectangle-2",
				stroke: "#000000",
				strokeWidth: 2,
				strokeLinecap: "square",
				points: "8 4 8 8 4 8"
			})
		]
	})
});
export default SvgCopyinline;
